import { render } from "./Default.vue?vue&type=template&id=1dea0a9a"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__